export const DEFAULT_LOCATE = 'vi'
export const CURRENCY_CONFIG = {
  decimal: '.',
  thousands: ',',
  precision: 0,
  prefix: '₫'
}

export const LOCATE_LANGUAGE = {
  VI: {
    locate: 'vi',
    language: 'vi_VN'
  },
  EN: {
    locate: 'en',
    language: 'en_US'
  }
}
export const CURRENCY_SYMBOL = {
  VND: '₫',
  USD: '$'
}

export const LOCALE_SUFFIX = {
  vi: '_vi_vn',
  en: '_en_us'
}

export const URL_IN_APP = {
  help_center: 'help-center'
}

export const COOKIE_NAME__TOKEN = 'token'
export const COOKIE_NAME__SSO_ZALOPAY_ACCESS_TOKEN = 's_z_a_token'
export const COOKIE_NAME__REFRESH_TOKEN = 'refresh_token'
export const COOKIE_NAME__PICKUP_LOCATION = 'pickup_location'
export const COOKIE_NAME__SELECTED_SERVICE_ID = 'service_id'
export const COOKIE_NAME__SELECTED_TRUCK_SERVICE_ID = 'truck_service_id'
export const COOKIE_EXPIRES_MAX_AGE__3M = 60
export const COOKIE_EXPIRES_MAX_AGE__6M = 120
export const COOKIE_NAME__RO_TOUR = 'ro_tour'
export const COOKIE_NAME__NEWORDER_RO_TOUR = 'n_o_ro_tour'
export const COOKIE_NAME__SHOW_PRESENT_NEWUI_VERSION_2 = 's_p_n_ui_version_2'
export const COOKIE_NAME__NEWORDER_TOUR = 'n_o_tour'
export const COOKIE_NAME__SELECT_ADDRESS_PICKUP_HINT = 's_a_p_hint'
export const COOKIE_NAME__SELECT_SERVICE_HINT = 's_s_hint'
export const COOKIE_NAME__SELECT_ADDRESS_HINT = 's_a_hint'
export const COOKIE_NAME__SELECT_ADDRESS_DROPOFF_HINT = 's_a_d_hint'
export const COOKIE_NAME__SELECT_PROMO_HINT = 's_p_hint'
export const COOKIE_NAME__ASK_NOTIFICATION_PERMISSION = 'a_n_permission'
export const COOKIE_NAME__APP_VERSION_1 = 'app_version_1'
export const COOKIE_NAME__ACTIVE_FB_ACCOUNT_ID = 'active_fb_account_id'
export const COOKIE_NAME__PAGE_INBOX_TOOLTIP = 'p_i_tooltip'
export const COOKIE_NAME__FORCE_LINK_SOCIAL_POPUP = 'f_l_s_popup'
export const COOKIE_NAME__SEND_SMS_SPECIAL_REQUEST_POPUP = 's_s_s_r_popup'
export const COOKIE_NAME__TRANSIT_INSURANCE_SPECIAL_REQUEST_UNCHECK = 't_i_s_r_uncheck'
export const COOKIE_NAME__CACHE_SHOW_LASTEST_ORDER = 'lastest_order'
export const COOKIE_NAME__SELECTED_TIME_PICKER = 's_t_pkr'
export const COOKIE_NAME__AFFILIATE_AT_SOURCE = '_aff_network'
export const COOKIE_NAME__AFFILIATE_AT_SID = '_aff_sid'
export const COOKIE_NAME__AFFILIATE_CLICK_ID = 'clickid'
export const COOKIE_NAME_SHOW_NOTIFY_CASH_BY_RECIPIENT = 's_n_c_b_recipient'
export const COOKIE_NAME__SELECTED_POD_SERVICE = 'pod_service'
export const LOCALSTORAGE_KEY_INFO_STOP_POINT = 'ro_info_stop_point'
export const LOCALSTORAGE_KEY_PICKUP_ADDRESS_RO = 'ro_pickup_address'
export const LOCALSTORAGE_KEY_HV_DATA_IMAGE = 'hv_img'
export const LOCALSTORAGE_KEY_TRANSIT_INSURANCE_TOOLTIP = 't_i_tooltip'
export const LOCALSTORAGE_KEY_BIGC_INVOICES_DATA = 'go_i_v_d'
export const LOCALSTORAGE_REUSE_ORDER_DATA = 'ro_ru_o_d'
export const LOCALSTORAGE_KEY_SGC_RO_DATA = 'sgc_i_v_d'
export const LOCALSTORAGE_KEY_EMBEDDED_TOKEN = 'angular-cache.caches.authCache.data.apiToken'
export const COOKIE_NAME__SHOW_ONBOARDING_TRUCK = 'o_b_t_s_popup'
export const COOKIE_NAME__SHOW_ONBOARDING_DRAFT_ORDER = 'draft_order_popup'
export const COOKIE_NAME__IS_FIRST_USE_DRAFT = 'show_tutor_draft_order'
export const COOKIE_NAME__INIT_LOCATION = 'init_location'

export const HEADER_NAME__WEB_IN_APP = 'WebInApp'

export const DEFAULT_COUNTRY_LIST = [
  {
    _id: 'VN',
    name: 'Vietnam',
    currency: 'VND',
    calling_code: 84
  }
]
export const DEFAULT_COUNTRY_ID = 'VN'

export const HTTP_REQUEST = {
  TIMEOUT: 12000,
  HEADERS: {
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: 'application/json'
  }
}

export const LOCAL_STORAGE_KEY__USER = 'user'
export const LOCAL_STORAGE_KEY__SELECTED_CID_IMAGES = 'selected_cid'
export const LOCAL_STORAGE_KEY__SUBMITTED_CID_IMAGES = 'submitted_cid'
export const LOCAL_STORAGE_KEY__MESSAGES = 'messages'
export const LOCAL_STORAGE_KEY__DISABLED_SAAS = 'disabled_saas'
export const LOCAL_STORAGE_KEY__LATEST_PAYMENT_METHOD = 'latest_payment_method'
export const LOCAL_STORAGE_PARNER_BOOKING_TABLE = 'partner_booking_table'
export const LOCAL_STORAGE_PARNER_CALLBACK_LOGS_TABLE = 'partner_callback_logs_table'
export const LOCAL_STORAGE_SENT_ACTIVATE_CODE_PAYLOAD = 'sent_a_v_p'
export const LOCAL_STORAGE_SENT_EDIT_BANK_OTP_PAYLOAD = 'sent_e_b_p'
export const LOCAL_STORAGE_KEY__FINGERPRINT = 'fp_pro'
export const LOCAL_STORAGE_KEY__SUBSCRIPTION_PAYMENT = 'subscription_payment_data'
export const LOCAL_STORAGE_KEY__PAYMENT_TYPE = 'payment_type'
export const LOCAL_STORAGE_KEY__FCM_TOKEN = 'fcm_sub'
export const LOCAL_STORAGE_KEY__WEB_IN_APP_INTRODUCTION = 'webinapp_intro'
export const LOCAL_STORAGE_KEY__PARTNER_GET_FROM_TOKEN = 'partner_get_from_token'

export const SESSION_STORAGE_NEW_ORDER_POPUP = 'new_order_popup'
export const SESSION_STORAGE_UPDATE_CATEGORY_MESSAGE_V2 = 'update_category_message_v2'
export const SESSION_STORAGE_ADD_BANK_TOOL_TIP = 'add_bank_tool_tip'
export const SESSION_STORAGE_SHOW_KYC_MODAL = 'show_kyc_modal'
export const SESSION_STORAGE_ORDER_ID_LATEST_CREATED = 'order_id_latest_created'

export const LOCAL_STORAGE_KEY__DISABLED_SSO_ZALOPAY = 'disabled_s_z_a'

export const API = {
  order: {
    countries: '/v1/order/countries',
    cities: '/v1/order/cities',
    service_types: '/v1/order/service_types',
    service_types_v3: '/api/v3/public/service/service-types',
    service_detail: '/v1/order/service_detail',
    detail: ({ order_id }) => `/api/v3/private/order/detail/${order_id}`,
    public_detail: ({ order_id, user_id }) =>
      `/api/v3/public/order/detail/${order_id}/user/${user_id}`,
    list: '/api/v3/public/order/list',
    locate_supplier: '/v1/order/locate_supplier',
    locate_multiple_suppliers: '/api/v3/private/aha-rent/order/locate_supplier',
    get_badge_list: '/api/v3/public/master-data/badge',
    rate_supplier: '/v1/order/rate_supplier',
    rate_supplier_v3: ({ order_id }) => `/api/v3/private/order/${order_id}/rate`,
    create_ticket: '/v1/ticket/create',
    estimated_fee: '/v1/order/estimated_fee',
    estimated_fee_v2: '/v2/order/estimated_fee',
    estimated_fee_v3_user: '/api/v3/private/order/estimate',
    estimated_fee_v3_partner: '/api/v3/partner/order/estimate',
    estimated_fee_rental: '/api/v3/private/aha-rent/order/estimate',
    cancel: '/v1/order/cancel',
    cancelGHN: ({ order_id }) => `/api/v3/saas/order/${order_id}/cancel`,
    cancel_v3_user: '/api/v3/private/order/cancel',
    cancel_v3_partner: '/api/v3/partner/order/cancel',
    create: '/v1/order/create',
    create_v3_user: '/api/v3/private/order/create',
    create_v3_partner: '/api/v3/partner/order/create',
    estimated_fee_saas_v3: '/v3/order-gw/estimated_fee',
    create_saas_v3: '/v3/order-gw/create',
    estimated_fee_v3: '/api/v3/private/order/estimate',
    // cancel_v3: '/api/v3/private/order/cancel',
    create_v3: '/api/v3/private/order/create',
    share_link: '/v1/order/shared_link',
    nearby_suppliers: '/v1/order/nearby_suppliers',
    verify_supplier_uniform: '/v1/order/verify_supplier_uniform',
    update_destination_info: '/v1/order/update_destination_info',
    update_recipient_address: '/v1/order/update_recipient_address',
    unconfirmed: '/order/unconfirmed',
    confirm: '/order/confirm',
    address_nation_wide: '/geo/v2/find_admin',
    items: {
      trends: '/api/v3/private/order/items/trends',
      suggestions: '/api/v3/private/order/items/autocomplete-items'
    },
    reimbursement: '/api/v3/private/order/reimbursement/confirm',
    search: '/api/v3/private/order/search',
    list_by_web: '/web/order/list',
    create_rental_order: '/api/v3/private/aha-rent/order/create',
    list_reason_cancel_order: '/api/v3/public/master-data/proof-of-work',
    suggestService: '/api/v3/private/service/truck_suggest',
    public_rating_comments: '/api/v3/public/master-data/proof-of-work',
    order_meta: '/api/v3/private/order/get-order-count'
  },
  chat: {
    unread: '/chat-history/unread'
  },
  order_gw: {
    estimated_fee: '/v3/order-gw/estimated_fee',
    create: '/v3/order-gw/create'
  },
  user: {
    auth: {
      loginV4: '/v4/auth/login',
      methodLoginV4: '/v4/auth/methods',
      verifyV4: 'v4/auth/verify',

      login: '/api/v3/public/user/login',
      partner_activate: '/api/v3/public/user/partner_activate',
      momo_activate: '/api/v3/public/user/momo_activate',
      viettel_activate: '/api/v3/public/user/vtp_activate',
      zalopay_activate: '/api/v3/public/user/zalopay_activate',
      logout: '/v1/user/logout',
      social_login: '/api/v3/public/user/social_login',
      activate: '/api/v3/public/user/activate',
      register: '/api/v3/public/user/register',
      link_social_account: '/v1/user/link_social_account',
      exchange_supplier: '/api/v3/public/user/exchange-supplier',
      verifyOTPLogin: '/api/v3/public/user/verify_otp',
      validatePassCode: '/api/v3/private/user/passcode/validate',
      updatePassCode: '/api/v3/private/user/passcode',
      forgotPassCode: '/api/v3/public/user/passcode/forgot',
      resetPassCode: '/api/v3/public/user/passcode/reset',
      refreshToken: '/api/v3/public/user/token/refresh'
    },
    add_point_reward: '/api/user/give_score',
    news: '/api/v3/private/user/news',
    public_news: '/api/v3/public/user/news',
    update_push: '/api/v3/private/user/push',
    update_language: '/api/v3/private/user/language',
    refresh_firebase_token: '/api/v3/private/user/refresh-firebase-token',
    get_push_data: '/v1/user/get_push_data',
    update_profile: '/api/v3/private/user/profile',
    verify: '/v1/user/verify',
    transaction: '/api/v3/private/payment/customers/transactions',
    balance: '/api/v3/private/payment/customers/balance',
    update_referral_code: '/api/v3/private/user/referral/update-code',
    // profile: '/v1/user/profile',
    profile: '/api/v3/private/user/self',
    log_event: '/v1/user/log_event',
    // get_promo_codes: '/v1/user/get_promo_codes', // promo v1
    get_promo_codes: '/api/v3/private/promotion/list', // promo v3
    get_promo_code: '/api/v3/private/promotion/',
    get_featured_banner: '/api/v3/public/master-data/featured-banner',
    get_otp: '/v1/user/get_otp',
    get_user_category: '/api/v3/public/master-data/user-category',
    saved_places: '/api/v3/private/user/user-place',
    check_valid_referrer: '/api/v3/private/user/referral/check-referrer-valid',
    get_referral_history: '/api/v3/private/user/referral/history',
    get_referral_detail: '/api/v3/private/user/referral',
    switch_status_auto_transfer_cod: '/v1/user/switch_status_auto_transfer_cod',
    subscription: {
      subscription_list: '/categories/list',
      subscription_detail: '/categories/detail',
      my_subscription_list: '/my_subscription/list',
      my_subscription_detail: '/my_subscription/detail',
      my_subscription_update: '/my_subscription/update',
      get_list_payment_methods_subscription: '/api/v3/private/payment/methods/subscription',
      checkStatusTransaction: '/api/v3/private/payment'
    },
    verify_account: '/v1/user/verify_account',
    screen_config: '/api/v3/public/master-data/screen-configs',
    generate_auth_token_hv: '/web/user/generate_token',
    favorite_drivers: '/api/v3/private/user/favorite_drivers',
    add_driver: '/v1/user/add_supplier',
    sso: {
      user_info: '/v1/user-info/me'
    },
    transaction_types: '/api/v3/public/master-data/transaction-types',
    delete_account: '/api/v3/private/user/delete_profile',
    trusted_partner: '/api/v3/private/user/trusted-partner'
  },
  supplier: {
    file: '/v1/supplier/file',
    profile: '/v1/supplier/profile',
    locate_supplier: '/v1/supplier/locate_supplier',
    get_child_list: '/v2/supplier/get_child_list',
    add_child_account: '/v2/supplier/add_child_account',
    activate_child_account: '/v2/supplier/activate_child_account',
    online_statistics: '/v2/supplier/online_statistics',
    broadcast_message: '/v2/supplier/broadcast_message',
    remove_child_account: '/v2/supplier/remove_child_account',
    update_language: '/v1/supplier/update_language',
    logout: '/v1/supplier/logout',
    assigning_list: '/v1/order/assigning_list',
    update_order_extra: '/v2/supplier/update_order_extra',
    update_status: '/v1/supplier/update_status'
  },
  store: {
    nearby_stores: '/v2/store/nearby_stores',
    campaign_list: '/v2/store/campaign_list',
    detail: '/v2/store/detail',
    cancel_order: '/v2/store/cancel_order',
    file: '/v2/store/file',
    estimated_fee: '/v2/store/estimated_fee',
    create_order: '/v2/store/create_order',
    rate_store: '/v2/store/rate_store',
    pay_momo_web_order: '/v2/store/pay_momo_web_order',
    pay_zalo_web_order: '/v2/store/pay_zalo'
  },
  route_planner: {
    geocode: '/v3/place/geocode',
    geocode_opstech_v3: '/geo/batch_geocode',
    optimize: '/kmeans_cvrp',
    samePrice: '/vrp'
  },
  payment: {
    // top_up: "/v1/payment/top_up",
    pay_order: '/api/v3/private/payment/pay/order',
    list_payment_methods: '/api/v3/private/payment/methods/',
    top_up: '/api/v3/private/payment/top-up',
    subscription: '/api/v3/private/payment/pay/subscription',
    add_bank_account: '/v1/user/add_bank_account',
    remove_bank_account: '/v1/user/remove_bank_account',
    update_balance: '/v1/user/update_balance',
    cod_transactions: '/api/v3/private/payment/customers/cod-transactions',
    zalopay: {
      binding: '/api/v3/private/payment/binding-wallet',
      check_remain: '/api/v3/private/payment/zalopay/check_remain',
      pay_order: '/api/v3/private/payment/zalopay/pay_order/'
    },
    shopeepay: {
      binding: '/api/v3/private/payment/binding-wallet',
      pay_token: '/api/v3/private/payment/pay-token'
    },
    unbinding: '/api/v3/private/payment/unbinding-wallet',
    pay: '/api/v3/private/payment/pay/',
    reimbursement: '/api/v3/private/payment/pay/reimbursement',
    virtual_account: '/api/v3/private/payment/bank/virtual-account',
    access_token: '/api/v3/private/payment/access-token',
    withdrawal: '/api/v3/private/payment/withdrawal',
    withdrawal_cod: '/api/v3/private/payment/methods/withdrawal_cod',
    payment_customers: '/api/v3/private/payment/customers/methods/',
    source_cards: '/api/v3/private/payment/sources/cards',
    set_default_payment: '/api/v3/private/payment/customers/methods',
    delete_payment: '/api/v3/private/payment/sources/cards'
  },
  // route_optimize: "https://ws.ahamove.com/lambda/staging/routing/vrp",
  admin: {
    file_upload: '/v2/ops/file_upload',
    user_upload: '/user_upload',
    user_verify: '/user_verify/',
    user_verify_hyperverge_v2: '/user_verify_hyperverge_v2'
  },
  ekyc: {
    file_upload: '/api/v3/private/ekyc/upload',
    verify: '/api/v3/private/ekyc/verify'
  },
  osrm: {
    driving: '/osrm/table/v1/driving/'
  },
  partner: {
    get_child_list: '/v1/partner/get_child_list',
    add_child_account: '/v1/partner/add_child_account',
    activate_child_account: '/v1/partner/activate_child_account',
    remove_child_account: '/v1/partner/remove_child_account',
    order_meta: '/web/api/v3/meta'
  },
  rest_api: {
    // baseURL = process.env.VUE_APP_REST_API
    ops_tech_place_autocomplete: '/web/v2/place/autocomplete',
    ops_tech_place_details: '/web/v2/place/details',
    ops_tech_place_autocomplete_public: '/web/public/place/autocomplete',
    ops_tech_place_details_public: '/web/public/place/details',
    place_autocomplete: '/place/autocomplete',
    place_details: '/place/details',
    pelias_extra_place: '/pelias/extra_place',
    pelias_autocomplete: '/pelias/autocomplete',
    route_optimize: '/ro/optimize',
    routing: '/ro/routing',
    load_data_partner: '/warehouse/packages',
    get_waiting_order_by_id: '/warehouse/package_details',
    update_stop_point_status: '/warehouse/update_packages',
    update_package_detail: '/warehouse/update_package_detail',
    upload_file: '/contact/upload',
    submit_contact_form: '/contact/submit',
    assign_order: '/order/assign_order',
    check_dispatcher: '/verify_dispatcher',
    get_ka_profile: '/api/v2/partners/ka_profile',
    get_partner: '/api/v2/partners/profile',
    get_partner_booking_list: '/order/list_by_partner',
    get_callback_logs: '/partner/get_callback_logs',
    partner_cancel_order: '/partner/cancel_order',
    check_duplicate_order: '/order/insights',
    set_order_tags: '/order/set_tags',
    get_user_orders: '/order/list',
    check_partner_user: '/partner/check_partner_user',
    get_service_types_by_user: '/statistics/service_types',
    get_statistics_general: '/statistics/general',
    get_statistics_distribution: '/statistics/distribution',
    get_statistics_performance: '/statistics/performance',
    get_statistics_distributionByDistrict: '/statistics/distribution_by_district',
    confirm_return_package: '/order/confirm_return_package',
    user_exchange_facebook_token: '/user/exchange_facebook_token',
    partner_set_saas_account: '/partner/set_saas_account',
    partner_set_child_account: '/partner/set_child_account',
    partner_reset_account: '/partner/reset_account',
    get_translation: '/get_translation',
    order_meta: '/order/meta',
    user_authorize_shared_link: '/user/authorize',
    supplier_nearby: '/supplier/nearby',
    get_draft_list: '/event/draft_list',
    get_draft_detail: '/event/draft_detail',
    save_as_draft: '/event/save_as_draft',
    place: {
      healthy_check: '/v3/place/ping',
      autocomplete: `/dplaces/web/v2/autocomplete`,
      autocomplete_v4: `/dplaces/web/v4/autocomplete`,
      google_autocomplete: '/gplaces/web/v2/autocomplete',
      geo_reverse: 'wgeo/v2/reverse',
      geocode: '/v3/place/geocode',
      geocode_reverse: '/v3/place/geocode_reverse',
      geocode_reverse_v3: '/v3/internal/geocoder/v2/reverse',
      find_admin: '/v3/place/find_admin', // Find administrative areas of all level of a given coordinate,
      find_admin_v3: '/geo/v2/find_admin',
      // details: '/v3/place/details',
      details: `${process.env.VUE_APP_ENV === 'production' ? '' : '/stg'}/dplaces/web/v2/detail`
    },
    public: {
      place: {
        healthy_check: '/v3/public/place/ping',
        autocomplete: '/v3/public/place/autocomplete',
        geo_reverse: 'wgeo/v2/reverse',
        geocode: '/v3/public/place/geocode',
        geocode_reverse: '/v3/public/place/geocode_reverse',
        geocode_reverse_v3: '/v3/public/geocoder/v2/reverse',
        find_admin: '/v3/public/place/find_admin', // Find administrative areas of all level of a given coordinate
        details: '/v3/public/place/details'
      }
    }
  },
  carrier: {
    child_account: {
      list: '/v2/supplier/get_child_list'
    }
  },
  remote_config: '/firebase/remote_config',
  nationwide: {
    estimated_fee: '/v1/nationwide/estimated_fee',
    create: '/v1/nationwide/create',
    cancel: '/v1/nationwide/cancel',
    cancelICT: ({ order_id }) => `/api/v3/private/intercity-order/${order_id}/cancel`,

    orderDetailICT: ({ order_id }) => `/api/v3/private/intercity-order/${order_id}`
  },
  kontakte: {
    get_customer_address: 'v1/kontakte/get_customer_address'
  },
  ticket: {
    create_ticket: '/api/v3/private/user/tickets',
    list: '/api/v3/private/user/tickets',
    comment: '/comments',
    rate_satisfaction: '/rate-satisfaction'
  },
  ticket_supplier: {
    create_ticket: '/api/v3/private/supplier/tickets',
    list: '/api/v3/private/supplier/tickets',
    comment: '/comments',
    rate_satisfaction: '/rate-satisfaction'
  },
  draft_order: {
    orderFormPublic: '/api/v3/public/order-form/',
    draftOrderPublic: '/api/v3/public/draft-order/create',
    createOrderForm: '/api/v3/private/order-form/create',
    getOrderForm: '/api/v3/private/order-form/',
    getListOrderForm: '/api/v3/private/order-form/list',
    createDraftOrder: '/api/v3/private/draft-order/create',
    getDraftOrder: '/api/v3/private/draft-order/',
    getListDraftOrder: '/api/v3/private/draft-order/list'
  },
  assets: {
    upload_image: '/api/v3/private/assets/images/upload',
    upload_order_image: '/api/v3/private/assets/order-images/upload',
    upload_chat_asset: '/api/v4/private/assets/chat-support-assets/upload'
  },
  WAREHOUSE: {
    nextStatus: '/api/v3/private/warehouse/orders/available_status',
    list: '/api/v3/private/warehouse/info',
    update_vendor_operation_mode: '/api/v3/private/warehouse/orders/operation-mode',
    update: '/api/v1/partner/warehouse/order/update_warehouse'
  },
  WAREHOUSE_V2: {
    getListPackage: '/api/v2/warehouse/packages',
    getListPackageFulfillment: '/api/v2/warehouse/packages/fulfillment/list',
    getMeta: '/api/v2/warehouse/meta',
    getPackage: '/api/v2/warehouse/packages',
    massUpdatePackages: '/api/v2/warehouse/packages/mass_update_packages',
    updatePackage: '/api/v2/warehouse/packages'
  },
  WAREHOUSE_V3: {
    getMeta: '/api/v3/warehouse/meta',
    vendors: '/api/v3/private/warehouse/vendors',
    update_vendor: '/api/v3/private/warehouse/orders/vendor',
    getPackage: '/api/v3/private/warehouse-tool/orders'
  },
  ro_autosave: {
    list: '/onwheel/v2/ro-tool-autosave/list',
    create: '/onwheel/v1/ro-tool-autosave',
    create_v2: '/onwheel/v2/ro-tool-autosave',
    bulk_update: '/onwheel/v1/ro-tool-autosave/bulk',
    bulk_delete: '/onwheel/v1/ro-tool-autosave/delete-bulk',
    list_v3: '/onwheel/v3/ro-tool-autosave/list',
    bulk_create_v3: '/onwheel/v3/ro-tool-autosave/bulk',
    store_location: '/onwheel/v1/store-location/list',
    create_v3: '/onwheel/v3/ro-tool-autosave'
  },
  bigc_api: {
    get_order: 'lms/order'
  },
  onwheel_utils: {
    osrm_distance: '/osrm/get_distance_from_pickup',
    sgc_estimate_fee: '/sgc/v1/estimate_fee',
    ac_estimate_fee: '/ancuong/v1/estimate_fee',
    ac_build_neighbor_matrix: '/ancuong/v1/build_neighbor_matrix',
    ac_get_vehicles: '/ancuong/v1/vehicles',
    ac_reset_vehicle: '/ancuong/v1/vehicles/reset',
    ac_set_default_vehicle: '/ancuong/v1/vehicles/set-default',
    ac_update_vehicle: '/ancuong/v1/vehicle/update',
    ac_remove_vehicle: '/ancuong/v1/vehicle/remove',
    ac_add_vehicle: '/ancuong/v1/vehicle/add',
    ac_bulk_update_data: '/ancuong/v1/bulk/update',
    ac_fetch_data: '/ancuong/v1/fetch_data',
    ac_find_od: '/ancuong/v1/find-od',
    ac_check_od: '/ancuong/v1/check-od',
    ac_generate_od: '/ancuong/v1/autogenerate_od',
    ac_trigger_optimize: '/ancuong/v2/trigger-optimize',
    ac_update_optimize: '/ancuong/v2/update-optimize',
    service_types: '/bigc/v1/service_types',
    master_data: {
      get: '/partner/v1/master-data/',
      action: '/partner/v1/master-data/action'
    },
    bigc_logs_action: '/bigc/v2/logs_action',
    bigc_check_tracking_number: '/bigc/v1/check_tracking_number',
    bigc_get_order: '/bigc/v3/order',
    bigc_get_outbound: '/bigc/v3/outbound',
    bigc_update_order: '/bigc/v3/webhook',
    get_report_url: '/v1/mass/report-url',
    admin_areas: '/v1/admin-areas'
  },
  onwheel_api: {
    bigc_users_list: '/onwheel/v1/bigc/users/list',
    users_list: '/onwheel/v1/users/list',
    es_search: '/proxy/api/es-search/order/',
    bigc_confirm_outbound: '/api/partner/bigc/confirm-outbound'
  },
  onwheel_geo: {
    find_admin_batch: '/v2/find_admin_batch',
    ac_build_fee_matrix: '/ancuong/v1/build_fee_matrix',
    batch_geocode: '/geo/batch_geocode',
    find_admin_batch_v3: '/api/v3/internal/geocoder/v3/find_admin_batch'
  },
  onwheel_roaas: {
    roaas: '/v1/ancuong',
    warmup: '/v1/ancuong_sample'
  },
  tips: '/api/v3/public/master-data/tips',
  master_data: {
    vehicle_types: '/api/v3/public/master-data/vehicle-types',
    prefer_services: '/api//v3/public/master-data/preferred-services',
    proof_of_work: `/api/v3/public/master-data/proof-of-work`
  },
  oauth: {
    validate: '/v1/sso/authorize/validate',
    grant_status: '/v1/sso/authorize/grant-status',
    issue: '/v1/sso/authorize/issue'
  }
}

export const ACCOUNT_STATUS = {
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED', // can not use all functions
  SUSPENDED: 'SUSPENDED' // user can use all functions except Order
}

export const PAYMENT_METHOD_TYPE = {
  EWALLET: 'e_wallet',
  CARD: 'card',
  CASH: 'cash',
  BALANCE: 'balance'
}

export const PAYMENT_METHOD_GROUP_TYPE = {
  CASHLESS: 'cash_less',
  CASH: 'cash'
}
export const DOMAIN = {
  ONWHEEL: 'onwheel.io'
}
export const ERROR_CODES = {
  SUSPENDED_USER: {
    code: 'SUSPENDED_USER',
    http_code: 406,
    description: 'Unfortunately, your account has been temporarily suspended'
  },
  ACTION_DUPLICATED: {
    code: 'ACTION_DUPLICATED',
    http_code: 409,
    description: 'Action duplicated'
  },
  ACTION_NOT_VALID: {
    code: 'ACTION_NOT_VALID',
    http_code: 406,
    description: 'Action is not valid'
  },
  ADDRESS_CODE_NOT_FOUND: {
    code: 'ADDRESS_CODE_NOT_FOUND',
    http_code: 404,
    description: 'Address code can not be found'
  },
  ADDRESS_NOT_FOUND: {
    code: 'ADDRESS_NOT_FOUND',
    http_code: 404,
    description: 'Address not found'
  },
  AMOUNT_IS_GREATER_THAN_BALANCE: {
    code: 'AMOUNT_IS_GREATER_THAN_BALANCE',
    http_code: 406,
    description: 'Amount is greater than balance credit'
  },
  AMOUNT_NOT_ENOUGH: {
    code: 'AMOUNT_NOT_ENOUGH',
    http_code: 406,
    description: 'Amount not valid'
  },
  AMOUNT_NOT_VALID: {
    code: 'AMOUNT_NOT_VALID',
    http_code: 406,
    description: 'Amount not valid'
  },
  BAD_REQUEST: {
    code: 'BAD_REQUEST',
    http_code: 400,
    description: 'Bad request, please check and try again.'
  },
  CANNOT_TRANSFER_COD: {
    code: 'CANNOT_TRANSFER_COD',
    http_code: 406,
    description: "Can't transfer COD"
  },
  CITY_NOT_FOUND: {
    code: 'CITY_NOT_FOUND',
    http_code: 404,
    description: 'Can not detect city from lat,lng'
  },
  COD_ACCOUNT_NOT_ENOUGH: {
    code: 'COD_ACCOUNT_NOT_ENOUGH',
    http_code: 406,
    description:
      'Sorry, it seems that your COD account is insufficient. Please check your COD account.'
  },
  COD_ACCOUNT_NOT_EXISTS: {
    code: 'COD_ACCOUNT_NOT_EXISTS',
    http_code: 406,
    description:
      'Sorry, it seems that your COD account is insufficient. Please check your COD account.'
  },
  CONCURRENT_ORDER_NOT_ALLOW: {
    code: 'CONCURRENT_ORDER_NOT_ALLOW',
    http_code: 406,
    description: 'Please wait for your order to be completed before creating another.'
  },
  CREATE_ORDER_ERROR: {
    code: 'CREATE_ORDER_ERROR',
    http_code: 400,
    description: 'Create Ahamove order error.'
  },
  DISTRICT_NOT_FOUND: {
    code: 'DISTRICT_NOT_FOUND',
    http_code: 404,
    description: 'Can not detect district from lat,lng'
  },
  DUPLICATED_S2C_TRACKING_NUMBER: {
    code: 'DUPLICATED_S2C_TRACKING_NUMBER',
    http_code: 409,
    description: 'Tracking number duplicated for S2C request'
  },
  DUPLICATED_WAREHOUSE_TRACKING_NUMBER: {
    code: 'DUPLICATED_WAREHOUSE_TRACKING_NUMBER',
    http_code: 409,
    description: 'Tracking number duplicated for warehouse request'
  },
  EMAIL_EXISTED: {
    code: 'EMAIL_EXISTED',
    http_code: 409,
    description: 'Email existed'
  },
  EMAIL_HAS_EXISTS: {
    code: 'EMAIL_HAS_EXISTS',
    http_code: 401,
    description: 'Email has exists, please check and try again.'
  },
  EMAIL_NOT_FOUND: {
    code: 'EMAIL_NOT_FOUND',
    http_code: 404,
    description: 'Email not found'
  },
  EXISTED_PARENT_ORDER: {
    code: 'EXISTED_PARENT_ORDER',
    http_code: 406,
    description: 'Parent order existed for {{ data.order_id }}'
  },
  FB_PAGE_EXISTED: {
    code: 'FB_PAGE_EXISTED',
    http_code: 409,
    description: 'This FB page has existed. Please use another FB page to verify your account.'
  },
  FILE_ID_NOT_FOUND: {
    code: 'FILE_ID_NOT_FOUND',
    http_code: 404,
    description: 'File ID not found!'
  },
  FILE_IMAGE_NOT_SQUARE: {
    code: 'FILE_IMAGE_NOT_SQUARE',
    http_code: 406,
    description: 'Image size is not square'
  },
  FILE_NOT_ALREADY_REVIEW: {
    code: 'FILE_NOT_ALREADY_REVIEW',
    http_code: 400,
    description: 'File has not been reviewed'
  },
  FILE_NOT_FOUND: {
    code: 'FILE_NOT_FOUND',
    http_code: 404,
    description: 'File not found!'
  },
  FORBIDDEN: {
    code: 'FORBIDDEN',
    http_code: 403,
    description: 'Permission denied, please check and try again.'
  },
  ID_EXISTED: {
    code: 'ID_EXISTED',
    http_code: 409,
    description: 'ID number existed'
  },
  IMEI_BLOCKED: {
    code: 'IMEI_BLOCKED',
    http_code: 403,
    description: 'IMEI is locked'
  },
  INVALID_ACCOUNT_STATUS: {
    code: 'INVALID_ACCOUNT_STATUS',
    http_code: 406,
    description: 'Account status not accepted'
  },
  INVALID_ACCOUNT_STATUS_WHEN_CHANGE_AUTO_ASSIGN: {
    code: 'INVALID_ACCOUNT_STATUS_WHEN_CHANGE_AUTO_ASSIGN',
    http_code: 406,
    description: 'Please switch your status to ONLINE to use this feature'
  },
  INVALID_ACTION: {
    code: 'INVALID_ACTION',
    http_code: 406,
    description: 'Turn off {{ data.type }} and try again'
  },
  INVALID_ACTIVATION_CODE: {
    code: 'INVALID_ACTIVATION_CODE',
    http_code: 406,
    description: 'Activation code not valid'
  },
  INVALID_AMOUNT: {
    code: 'INVALID_AMOUNT',
    http_code: 400,
    description: 'Invalid amount'
  },
  INVALID_ASSIGN_TYPE: {
    code: 'INVALID_ASSIGN_TYPE',
    http_code: 406,
    description: 'Invalid type'
  },
  INVALID_CHILD_ORDER_STATUS: {
    code: 'INVALID_CHILD_ORDER_STATUS',
    http_code: 406,
    description: 'Child order status not valid'
  },
  INVALID_COD_CUSTOMER: {
    code: 'INVALID_COD_CUSTOMER',
    http_code: 406,
    description: 'To use COD service, please contact our hotline - 1900 5454 11'
  },
  INVALID_COD_DISCREPANCY: {
    code: 'INVALID_COD_DISCREPANCY',
    http_code: 406,
    description: 'COD discrepancy not valid'
  },
  INVALID_CONTENT_TYPE: {
    code: 'INVALID_CONTENT_TYPE',
    http_code: 415,
    description: 'Unsupported Media Type, please check and try again.'
  },
  INVALID_DATA: {
    code: 'INVALID_DATA',
    http_code: 400,
    description: 'Invalid data'
  },
  INVALID_DEPOSIT_AMOUNT: {
    code: 'INVALID_DEPOSIT_AMOUNT',
    http_code: 406,
    description: 'Deposit amount is not valid'
  },
  INVALID_DISTANCE: {
    code: 'INVALID_DISTANCE',
    http_code: 406,
    description: 'Distance {{ data.distance }} km not valid'
  },
  INVALID_EMAIL: {
    code: 'INVALID_EMAIL',
    http_code: 400,
    description: 'Email invalid'
  },
  INVALID_FILE_SIZE: {
    code: 'INVALID_FILE_SIZE',
    http_code: 406,
    description: 'File size should be less than 3M'
  },
  INVALID_FORMAT_MOBILE: {
    code: 'INVALID_FORMAT_MOBILE',
    http_code: 409,
    description: 'Please register with a new phone number (10 digits) to continue'
  },
  INVALID_FORMAT_NUMBER: {
    code: 'INVALID_FORMAT_NUMBER',
    http_code: 409,
    description: 'Please register with a new phone number (10 digits) to continue'
  },
  INVALID_FUTURE_ORDER_TIME: {
    code: 'INVALID_FUTURE_ORDER_TIME',
    http_code: 406,
    description: 'Booking time cannot exceed one week from now.'
  },
  INVALID_HUB_DEVICE_TYPE: {
    code: 'INVALID_HUB_DEVICE_TYPE',
    http_code: 406,
    description:
      'From now on, we do not allow drivers with an iOS device to accept HUB order. Please contact our customer service for more information.'
  },
  INVALID_IDLE_UNTIL: {
    code: 'INVALID_IDLE_UNTIL',
    http_code: 406,
    description: 'Idle until is less than current time'
  },
  INVALID_IMAGE_SIZE: {
    code: 'INVALID_IMAGE_SIZE',
    http_code: 400,
    description: 'Only support size 64 or 128'
  },
  INVALID_LANGUAGE: {
    code: 'INVALID_LANGUAGE',
    http_code: 406,
    description: 'Language not valid!'
  },
  INVALID_MAX_COD: {
    code: 'INVALID_MAX_COD',
    http_code: 406,
    description:
      'Unfortunately, this service does not support total COD larger than đ{{ data.max_cod }}'
  },
  INVALID_MAX_STOP_POINT: {
    code: 'INVALID_MAX_STOP_POINT',
    http_code: 406,
    description: 'Allow maximum {{ data.max_stop_point }} stop points'
  },
  INVALID_MIN_STOP_POINT: {
    code: 'INVALID_MIN_STOP_POINT',
    http_code: 406,
    description: 'Allow minimum {{ data.min_stop_point }} stop points'
  },
  INVALID_MOBILE_NUMBER: {
    code: 'INVALID_MOBILE_NUMBER',
    http_code: 406,
    description: 'Mobile number not valid'
  },
  INVALID_ORDER_CONFIRMATION: {
    code: 'INVALID_ORDER_CONFIRMATION',
    http_code: 406,
    description: 'Order confimation is not valid'
  },
  INVALID_ORDER_STATUS: {
    code: 'INVALID_ORDER_STATUS',
    http_code: 406,
    description: 'Order status is not valid'
  },
  INVALID_PARAMETER: {
    code: 'INVALID_PARAMETER',
    http_code: 400,
    description: 'Input data is not valid'
  },
  INVALID_PAST_ORDER_TIME: {
    code: 'INVALID_PAST_ORDER_TIME',
    http_code: 406,
    description: 'Booking time must be greater than now.'
  },
  INVALID_PAYMENT_METHOD: {
    code: 'INVALID_PAYMENT_METHOD',
    http_code: 406,
    description: 'Invalid payment method, please check and try again.'
  },
  INVALID_PAYMENT_PROVIDER: {
    code: 'INVALID_PAYMENT_PROVIDER',
    http_code: 400,
    description: 'Invalid Payment Provider, please check and try again.'
  },
  INVALID_REBROADCAST_TIME: {
    code: 'INVALID_REBROADCAST_TIME',
    http_code: 406,
    description: 'Rebroadcast time is not valid'
  },
  INVALID_REFERRAL_CODE: {
    code: 'INVALID_REFERRAL_CODE',
    http_code: 404,
    description: 'Invalid referral code'
  },
  INVALID_REQUEST_METHOD: {
    code: 'INVALID_REQUEST_METHOD',
    http_code: 405,
    description: 'Method not allowed, please check and try again.'
  },
  INVALID_SERVICE_HOUR: {
    code: 'INVALID_SERVICE_HOUR',
    http_code: 406,
    description: 'The service is only available from {{ data.from_hour }}h'
  },
  INVALID_SPECIAL_REQUEST: {
    code: 'INVALID_SPECIAL_REQUEST',
    http_code: 406,
    description: 'Invalid request'
  },
  INVALID_SUPPLIER_STATUS: {
    code: 'INVALID_SUPPLIER_STATUS',
    http_code: 406,
    description: 'Status not accepted'
  },
  INVALID_SUPPLIER_STATUS_WHEN_OFFLINE: {
    code: 'INVALID_SUPPLIER_STATUS_WHEN_OFFLINE',
    http_code: 406,
    description: 'Order not found'
  },
  INVALID_SUSPENDED_TIME: {
    code: 'INVALID_SUSPENDED_TIME',
    http_code: 406,
    description: 'Suspend time not valid'
  },
  INVALID_TOKEN: {
    code: 'INVALID_TOKEN',
    http_code: 401,
    description: 'Invalid or expired token, please check and try again.'
  },
  INVALID_TRANSACTION_TYPE: {
    code: 'INVALID_TRANSACTION_TYPE',
    http_code: 406,
    description: 'Type not valid'
  },
  INVALID_USER_PARTNER: {
    code: 'INVALID_USER_PARTNER',
    http_code: 406,
    description:
      "User's phone number {{ data.user_id }} associated with token {{ data.token }} has been used for a partner"
  },
  INVALID_WITHDRAWAL_OPTION: {
    code: 'INVALID_WITHDRAWAL_OPTION',
    http_code: 406,
    description: 'Unfortunately, we do not support this withdraw option'
  },
  LOCKED_IMEI: {
    code: 'LOCKED_IMEI',
    http_code: 403,
    description: 'IMEI is locked'
  },
  MISSING_BANK_ACCOUNT_INFORMATION: {
    code: 'MISSING_BANK_ACCOUNT_INFORMATION',
    http_code: 406,
    description: 'You did not provide bank account information'
  },
  MISSING_PARAMETER: {
    code: 'MISSING_PARAMETER',
    http_code: 400,
    description: 'Missing parameter'
  },
  MISSING_PATH_INFO: {
    code: 'MISSING_PATH_INFO',
    http_code: 400,
    description: 'This service must at least have a pick up and a drop-off in the path'
  },
  MISSING_REQUIRED_FIELD: {
    code: 'MISSING_REQUIRED_FIELD',
    http_code: 400,
    description: 'Missing required field'
  },
  MOBILE_NOT_FOUND: {
    code: 'MOBILE_NOT_FOUND',
    http_code: 404,
    description: 'Mobile not found'
  },
  MOBILE_NUMBER_EXISTED: {
    code: 'MOBILE_NUMBER_EXISTED',
    http_code: 409,
    description: 'Mobile number existed'
  },
  MOMO_DENY_TOPUP_WITH_SUPPLIER: {
    code: 'MOMO_DENY_TOPUP_WITH_SUPPLIER',
    http_code: 406,
    description: 'Top up with MoMo for supplier not supported yet.'
  },
  MOMO_ERROR_ADDING_LOG: {
    code: 'MOMO_ERROR_ADDING_LOG',
    http_code: 400,
    description: 'Operation not completed successfully, please log out and try again.'
  },
  MOMO_ERROR_CREATING_QR: {
    code: 'MOMO_ERROR_CREATING_QR',
    http_code: 400,
    description: 'Create QR-MoMo failed.'
  },
  MOMO_ERROR_PARSING_RESPONSE: {
    code: 'MOMO_ERROR_PARSING_RESPONSE',
    http_code: 400,
    description: 'Create QR-MoMo failed.'
  },
  MOMO_INVALID_CHECKSUM_CONFIRM_TOPUP: {
    code: 'MOMO_INVALID_CHECKSUM_CONFIRM_TOPUP',
    http_code: 406,
    description: 'QR String not valid.'
  },
  MOMO_REQUIRED_RETURN_URL: {
    code: 'MOMO_REQUIRED_RETURN_URL',
    http_code: 400,
    description: 'Required return_url and must be non empty string.'
  },
  MOMO_VERIFY_FAILED: {
    code: 'MOMO_VERIFY_FAILED',
    http_code: 406,
    description: '{{ data.description }}'
  },
  NEW_ORDER_NOT_ALLOW: {
    code: 'NEW_ORDER_NOT_ALLOW',
    http_code: 406,
    description:
      "You've just created an order. Please wait for a few seconds before creating another."
  },
  NOT_AUTHORIZED: {
    code: 'NOT_AUTHORIZED',
    http_code: 401,
    description: 'Not authorized, please check and try again.'
  },
  NOT_ENOUGH_AMOUNT: {
    code: 'NOT_ENOUGH_AMOUNT',
    http_code: 406,
    description: 'Current amount is not enough'
  },
  NOT_ENOUGH_CREDIT: {
    code: 'NOT_ENOUGH_CREDIT',
    http_code: 406,
    description: 'Not enough credit'
  },
  ZALO_WALLET_NOT_ENOUGH_CREDIT: {
    code: 'ZALOPAY_WALLET_NOT_ENOUGH_CREDIT',
    http_code: 406,
    description: 'Not enough credit'
  },
  NOT_ENOUGH_DEPOSIT_AMOUNT: {
    code: 'NOT_ENOUGH_DEPOSIT_AMOUNT',
    http_code: 406,
    description: 'Deposit amount is not enough'
  },
  NOT_FOUND: {
    code: 'NOT_FOUND',
    http_code: 404,
    description: 'Not found, please check and try again.'
  },
  NOT_SUPPORT_ADVANCE_BOOKING: {
    code: 'NOT_SUPPORT_ADVANCE_BOOKING',
    http_code: 406,
    description: 'This service does not support advance booking.'
  },
  ORDER_ALREADY_REFUNDED: {
    code: 'ORDER_ALREADY_REFUNDED',
    http_code: 406,
    description: 'Order already refuned'
  },
  ORDER_ALREADY_TRANSFERRED_COD: {
    code: 'ORDER_ALREADY_TRANSFERRED_COD',
    http_code: 406,
    description: 'Order already transferred COD'
  },
  ORDER_NOT_COMPLETED: {
    code: 'ORDER_NOT_COMPLETED',
    http_code: 406,
    description: 'Order must be completed'
  },
  ORDER_NOT_COMPLETELY: {
    code: 'ORDER_NOT_COMPLETELY',
    http_code: 406,
    description: 'You need to complete all stop point before complete order'
  },
  ORDER_NOT_FOUND: {
    code: 'ORDER_NOT_FOUND',
    http_code: 404,
    description: 'Order not found'
  },
  ORDER_NOT_TRANSFER_COD_YET: {
    code: 'ORDER_NOT_TRANSFER_COD_YET',
    http_code: 406,
    description: 'Order not transfer COD yet'
  },
  OTP_EXPIRED: {
    code: 'OTP_EXPIRED',
    http_code: 400,
    description: 'Your activation code is expired.'
  },
  OVER_QUOTA_FOR_ONE_DAY: {
    code: 'OVER_QUOTA_FOR_ONE_DAY',
    http_code: 406,
    description: 'Quota for one day is over'
  },
  PAYMENT_NOT_ACCEPTABLE: {
    code: 'PAYMENT_NOT_ACCEPTABLE',
    http_code: 406,
    description: 'Payment not acceptable'
  },
  PROMO_CODE_EXISTED: {
    code: 'PROMO_CODE_EXISTED',
    http_code: 400,
    description: 'Promotion code already existed, please check and try again.'
  },
  PROMO_DEVICES_NOT_VALID: {
    code: 'PROMO_DEVICES_NOT_VALID',
    http_code: 406,
    description: 'Promo code only applied for specific device types'
  },
  PROMO_DISTRICTS_NOT_VALID: {
    code: 'PROMO_DISTRICTS_NOT_VALID',
    http_code: 406,
    description: "Unfortunately, this promo code can't be applied in this area"
  },
  PROMO_EXPIRED: {
    code: 'PROMO_EXPIRED',
    http_code: 406,
    description: 'Promo code has expired'
  },
  PROMO_FIRST_ORDER_NOT_VALID: {
    code: 'PROMO_FIRST_ORDER_NOT_VALID',
    http_code: 406,
    description: 'Promo code only applied for first order with specific requirements'
  },
  PROMO_MAX_USE_NOT_VALID: {
    code: 'PROMO_MAX_USE_NOT_VALID',
    http_code: 406,
    description: 'Unfortunately, this promo code has expired'
  },
  PROMO_MAX_USE_NOT_VALID_IMEI_CHECK: {
    code: 'PROMO_MAX_USE_NOT_VALID_IMEI_CHECK',
    http_code: 406,
    description: "You've already reached the limit of this promo code"
  },
  PROMO_MAX_USE_PER_USER_NOT_VALID: {
    code: 'PROMO_MAX_USE_PER_USER_NOT_VALID',
    http_code: 406,
    description: 'Unfortunately, this promo code has expired'
  },
  PROMO_NOT_FOUND: {
    code: 'PROMO_NOT_FOUND',
    http_code: 404,
    description: 'Promo code does not exist in system'
  },
  PROMO_NOT_IN_VALID_HOURS: {
    code: 'PROMO_NOT_IN_VALID_HOURS',
    http_code: 406,
    description: 'This promo code is only be applied in specific time range'
  },
  PROMO_NOT_VALID: {
    code: 'PROMO_NOT_VALID',
    http_code: 406,
    description: 'Oops, this promo code is invalid!'
  },
  PROMO_PARTNER_NOT_VALID: {
    code: 'PROMO_PARTNER_NOT_VALID',
    http_code: 406,
    description: 'Unfortunately, this promo code can only be applied for booking from our partners'
  },
  PROMO_PAYMENT_NOT_VALID: {
    code: 'PROMO_PAYMENT_NOT_VALID',
    http_code: 406,
    description: 'Unfortunately, this promo can only be applied for some specific payment type'
  },
  PROMO_REACH_DAILY_LIMIT: {
    code: 'PROMO_REACH_DAILY_LIMIT',
    http_code: 406,
    description: '{{Unfortunately, this promo code has exceed today limit'
  },
  PROMO_SERVICES_NOT_VALID: {
    code: 'PROMO_SERVICES_NOT_VALID',
    http_code: 406,
    description: "Unfortunately, this promo code can't be used for this type of service"
  },
  PROMO_TAGS_NOT_VALID: {
    code: 'PROMO_TAGS_NOT_VALID',
    http_code: 406,
    description: 'Promo code only applied for specific customers'
  },
  PROMO_USER_ID_NOT_VALID: {
    code: 'PROMO_USER_ID_NOT_VALID',
    http_code: 406,
    description: 'Promo code only applied for specific customers'
  },
  REFEREE_NOT_FOUND: {
    code: 'REFEREE_NOT_FOUND',
    http_code: 404,
    description: 'Referee can not be found'
  },
  REFERRAL_CODE_EXISTED: {
    code: 'REFERRAL_CODE_EXISTED',
    http_code: 409,
    description: 'Referral code already existed'
  },
  REFERRAL_CODE_INVALID: {
    code: 'REFERRAL_CODE_INVALID',
    http_code: 404,
    description: 'Invalid referral code, please check again'
  },
  REFERRAL_CODE_NOT_EXISTS: {
    code: 'REFERRAL_CODE_NOT_EXISTS',
    http_code: 404,
    description: 'Referral code does not exist'
  },
  REFERRAL_CONDITION_ERROR: {
    code: 'REFERRAL_CONDITION_ERROR',
    http_code: 406,
    description: 'The referrer does not match the referral rule'
  },
  REFERRAL_SAME_ID: {
    code: 'REFERRAL_SAME_ID',
    http_code: 406,
    description: 'The referrer and referee have same ID'
  },
  REFRESH_TOKEN_NOT_FOUND: {
    code: 'REFRESH_TOKEN_NOT_FOUND',
    http_code: 404,
    description: 'Refresh token not found'
  },
  REQUEST_NOT_FOUND: {
    code: 'REQUEST_NOT_FOUND',
    http_code: 404,
    description: 'Request not found'
  },
  SAVED_PLACES_LIMIT: {
    code: 'SAVED_PLACES_LIMIT',
    http_code: 406,
    description: 'Saved places exceed the limit'
  },
  SERVICE_NOT_FOUND: {
    code: 'SERVICE_NOT_FOUND',
    http_code: 404,
    description: 'Service does not exist'
  },
  SOCKET_SENT_FAILED: {
    code: 'SOCKET_SENT_FAILED',
    http_code: 406,
    description: 'Package is sent failed through socket'
  },
  SPECIAL_REQUEST_REQUIRED: {
    code: 'SPECIAL_REQUEST_REQUIRED',
    http_code: 406,
    description: 'Sorry, this service must have at least one special request.'
  },
  SUCCESS: { code: 'SUCCESS', http_code: 200, description: 'Success' },
  SUPPLIER_DEACTIVATED: {
    code: 'SUPPLIER_DEACTIVATED',
    http_code: 403,
    description: 'Supplier is deactivated'
  },
  SUPPLIER_HAS_EXISTS: {
    code: 'SUPPLIER_HAS_EXISTS',
    http_code: 401,
    description: 'Supplier has exists, please check and try again.'
  },
  SUPPLIER_IS_PENDING_UNIFORM_DETECTION: {
    code: 'SUPPLIER_IS_PENDING_UNIFORM_DETECTION',
    http_code: 406,
    description: ' please confirm your uniform to continue'
  },
  SUPPLIER_NOT_ACTIVATE: {
    code: 'SUPPLIER_NOT_ACTIVATE',
    http_code: 403,
    description: 'Supplier is not activated'
  },
  SUPPLIER_NOT_FOUND: {
    code: 'SUPPLIER_NOT_FOUND',
    http_code: 404,
    description: 'Supplier not found, please check and try again.'
  },
  SUPPLIER_SUSPENDED: {
    code: 'SUPPLIER_SUSPENDED',
    http_code: 406,
    description: 'Sorry, your account has been temporarily suspended'
  },
  TOKEN_EXPIRED: {
    code: 'TOKEN_EXPIRED',
    http_code: 401,
    description: 'The access token has expired'
  },
  REFRESH_TOKEN_HAS_EXPIRED: {
    code: 'REFRESH_TOKEN_HAS_EXPIRED',
    http_code: 401,
    description: 'The access token has expired'
  },
  TOKEN_NOT_FOUND: {
    code: 'TOKEN_NOT_FOUND',
    http_code: 404,
    description: 'Token does not exist in system'
  },
  TOTAL_PAY_NOT_VALID: {
    code: 'TOTAL_PAY_NOT_VALID',
    http_code: 402,
    description: 'Total pay not valid'
  },
  TRANSACTION_DUPLICATED: {
    code: 'TRANSACTION_DUPLICATED',
    http_code: 409,
    description: 'Transaction duplicated.'
  },
  TRANSACTION_INFO_DOES_NOT_MATCH: {
    code: 'TRANSACTION_INFO_DOES_NOT_MATCH',
    http_code: 409,
    description: 'Transaction info does not match.'
  },
  TRANSFER_COD_FAILED: {
    code: 'TRANSFER_COD_FAILED',
    http_code: 406,
    description: 'Invalid type'
  },
  UNIFORM_CHECKING: {
    code: 'UNIFORM_CHECKING',
    http_code: 406,
    description: 'Unfortunately, please confirm your uniform to continue'
  },
  USER_ACTIVE_FAIL: {
    code: 'USER_ACTIVE_FAIL',
    http_code: 400,
    description: 'Active user fail, please try again.'
  },
  USER_DEACTIVATED: {
    code: 'USER_DEACTIVATED',
    http_code: 403,
    description: 'User is deactivated'
  },
  USER_NOT_FOUND: {
    code: 'USER_NOT_FOUND',
    http_code: 404,
    description: 'This user does not exist'
  },
  USER_STATUS_NOT_ACCEPTED: {
    code: 'USER_STATUS_NOT_ACCEPTED',
    http_code: 406,
    description: 'The status of this user access deined.'
  },
  VNPAY_ERROR_ADDING_LOG: {
    code: 'VNPAY_ERROR_ADDING_LOG',
    http_code: 400,
    description: 'Operation not completed successfully, please log out and try again.'
  },
  VNPAY_ERROR_CREATING_QR: {
    code: 'VNPAY_ERROR_CREATING_QR',
    http_code: 400,
    description: 'Create QR-VNPay failed.'
  },
  VNPAY_ERROR_PARSING_RESPONSE: {
    code: 'VNPAY_ERROR_PARSING_RESPONSE',
    http_code: 400,
    description: 'Create QR-VNPay failed.'
  },
  VNPAY_INVALID_CHECKSUM_RESPONSE: {
    code: 'VNPAY_INVALID_CHECKSUM_RESPONSE',
    http_code: 406,
    description: 'QR String not valid.'
  },
  WARD_LIST_IS_EMPTY: {
    code: 'WARD_LIST_IS_EMPTY',
    http_code: 406,
    description: 'Ward list can not be empty'
  },
  WRONG_ACTIVE_CODE: {
    code: 'WRONG_PASSCODE',
    http_code: 400,
    description: 'Passcode code wrong, please check again.'
  },
  WRONG_OTP_CODE: {
    code: 'WRONG_OTP',
    http_code: 401,
    description: 'Mã OTP không chính xác. Bạn còn x lần thử lại.'
  },
  BANNED_USER: {
    code: 'BANNED_USER',
    http_code: 403,
    description: 'Bạn đã nhập sai OTP 5 lần liên tiếp.'
  },

  DEACTIVATED_USER_WRONG_PASSCODE: {
    code: 'DEACTIVATED_USER_WRONG_PASSCODE',
    http_code: 403,
    description: 'Passcode code wrong, please check again.'
  },
  ZALOPAY_ERROR_ADDING_LOG: {
    code: 'ZALOPAY_ERROR_ADDING_LOG',
    http_code: 400,
    description: 'Operation not completed successfully, please log out and try again.'
  },
  ZALOPAY_ERROR_CREATING_QR: {
    code: 'ZALOPAY_ERROR_CREATING_QR',
    http_code: 400,
    description: 'Create QR-ZaloPay failed.'
  },
  ZALOPAY_ERROR_PARSING_RESPONSE: {
    code: 'ZALOPAY_ERROR_PARSING_RESPONSE',
    http_code: 400,
    description: 'Create QR-ZaloPay failed.'
  },
  USER_NOT_BINDING: {
    code: 'USER_NOT_BINDING',
    http_code: 406,
    description: "You're not binding wallet with ZaloPay"
  },
  TRANSACTION_IS_PROCESSING: {
    code: 'TRANSACTION_IS_PROCESSING',
    http_code: 406,
    description: 'Giao dịch vẫn đang được xử lý, vui lòng thử lại sau'
  },
  NOT_ENOUGH_NUMBER_DOCS: {
    code: 'NOT_ENOUGH_NUMBER_DOCS',
    http_code: 400,
    description: 'Tài liệu bao gồm 2 mặt chứng minh nhân dân và ảnh đại diện'
  },
  REIMBURSEMENT_HAS_PAID: {
    code: 'REIMBURSEMENT_HAS_PAID',
    http_code: 400,
    description: 'Đơn hàng đã thanh toán phí bồi hoàn, vui lòng kiểm tra lại'
  },
  REIMBURSEMENT_TRANSFERRED: {
    code: 'REIMBURSEMENT_TRANSFERRED',
    description: 'Phí đã được hoàn trước đó.',
    http_code: 409
  },
  DUPLICATE_TRACKING_NUMBER: {
    code: 'DUPLICATE_TRACKING_NUMBER',
    http_code: 409,
    description:
      'Tracking number {{ tracking_number }} đã tồn tại trong đơn hàng {{ order_id }} với trạng thái đang xử lý'
  },
  DOCS_CONTAINS_IN_REVIEW: {
    code: 'DOCS_CONTAINS_IN_REVIEW',
    description: 'Chúng tôi đang xem xét chứng minh nhân dân và ảnh của bạn',
    http_code: 400
  },
  USER_KYC_ACCOUNT_EXIST: {
    code: 'ACCOUNT_EXIST',
    description: 'Khách hàng đã tồn tại trong hệ thống',
    http_code: 400
  },
  WRONG_PASSCODE: {
    code: 'WRONG_PASSCODE',
    http_code: 400,
    description: 'passcode wrong, please check again.'
  }
}

export const LOCAL_STORAGE_KEY__RECENT_IMAGES = 'ls.recent_uploads'
export const LOCAL_STORAGE_MAX_IMAGES_CACHE = 10
export const RECENT_ADDRESS_LOGS_LIMIT = 10

export const DATABASE_NAME = 'ahamove_db'
export const DATABASE_VERSION = 1

export const ORDER_STATUS = {
  ALL: 'ALL',
  CONFIRMING: 'CONFIRMING',
  PAYING: 'PAYING',
  IDLE: 'IDLE',
  ASSIGNING: 'ASSIGNING',
  ACCEPTED: 'ACCEPTED',
  IN_PROCESS: 'IN PROCESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  IN_RETURN: 'IN_RETURN'
}

export const RECORDS_ORDER_STATUS = {
  ALL: 'ALL',
  CONFIRMING: 'CONFIRMING',
  PAYING: 'PAYING',
  IDLE: 'IDLE',
  ASSIGNING: 'ASSIGNING',
  ACCEPTED: 'ACCEPTED',
  IN_PROCESS: 'IN PROCESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED'
}

export const REFERRAL_STATUS = {
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING'
}

export const SERVICE_REQUESTS = {
  BOOLEAN: 'BOOLEAN',
  COMMISSION_DISTANCE_PERCENTAGE: 'COMMISSION_DISTANCE_PERCENTAGE',
  PER_UNIT: 'PER_UNIT',
  ITEM: 'ITEM',
  COMMISSION_PERCENTAGE: 'COMMISSION_PERCENTAGE',
  COMMISSION_FLAT: 'COMMISSION_FLAT',
  TIER: 'TIER',
  FRAGILE: 'FRAGILE',
  INSURANCE: 'INSURANCE'
}

export const CREATE_ORDER_ERROR_TEMPLATE = {
  COD_IS_NOT_ALLOWED: 'COD is not allowed for individual customer',
  NOT_ENOUGH_CREDIT: 'Not enough credit',
  BOOKING_TIME_INVALID: 'Booking time not valid',
  DISTANCE_NOT_VALID: 'Distance not valid'
}

export const CHAT = {
  MESSAGE_STATUS: {
    SENT: 1,
    READ: 2
  }
}

export const SHOWN_SET_TIME_INTRO = 'shown_settime_intro'

export const RO_TRANSPORT_MODE = {
  DELIVERY: '1N',
  PICKUP: 'N1',
  ROUNDTRIP: '1N1'
}

export const EXPORT_ORDER = {
  maxRecords: 500,
  count: 50
}

export const RO_ALGORITHM = {
  VRP: 'vrp',
  // KMEAN: "kmeans_cvrp",
  SDVRP: 'sdvrp',
  TWVRP: 'twvrp',
  P2P: 'normal',
  GROUPBY: 'groupby'
}

export const RO_EXPERT = 'RO_EXPERT'
export const RO_SME = 'SME_RO'
export const MERCHANT_TAG = 'MERCHANT_GOSHOP'
export const MAX_DISTANCE = 30 * 1000 // 30km
export const STOP_POINT_STATUS = {
  VERIFYING: 'VERIFYING',
  WAITING_FOR_RO: 'WAITING_FOR_RO',
  NEED_RETURN_TO_PARTNER_ASAP: 'NEED_RETURN_TO_PARTNER_ASAP',
  NEED_RETURN_TO_PARTNER_EOD: 'NEED_RETURN_TO_PARTNER_EOD',
  RETURNED_TO_PARTNER: 'RETURNED_TO_PARTNER',
  FAILED: 'FAILED',
  WH_PENDING: 'WH_PENDING',
  TRANSPORTING: 'TRANSPORTING',
  TRANSITING: 'TRANSITING',
  RETURN_FAILED: 'RETURN_FAILED',
  RETURNING: 'RETURNING',
  RETURN_PICKING: 'RETURN_PICKING',
  PICKUP_FAILED: 'PICKUP_FAILED'
}

export const API_IMPORT_STATUS = Object.keys(STOP_POINT_STATUS).map((key) => STOP_POINT_STATUS[key])
export const STATUS_FOR_UPDATE = [
  STOP_POINT_STATUS['WAITING_FOR_RO'],
  STOP_POINT_STATUS['IDLE_FOR_RO'],
  STOP_POINT_STATUS['NEED_RETURN_TO_PARTNER_ASAP'],
  STOP_POINT_STATUS['NEED_RETURN_TO_PARTNER_EOD'],
  STOP_POINT_STATUS['RETURNED_TO_PARTNER'],
  STOP_POINT_STATUS['IDLE'],
  STOP_POINT_STATUS['FAILED'],
  STOP_POINT_STATUS['WH_PENDING'],
  STOP_POINT_STATUS['TRANSPORTING'],
  STOP_POINT_STATUS['TRANSITING'],
  STOP_POINT_STATUS['RETURN_FAILED'],
  STOP_POINT_STATUS['RETURN_PICKING'],
  STOP_POINT_STATUS['RETURNING'],
  STOP_POINT_STATUS['PICKUP_FAILED']
]

export const WAREHOUSE_STATUS_TO_CALLBACK_STATUS = {
  VERIFYING: ['AHM_PICKED_UP', 'IN PROCESS'],
  FAILED_1: ['IDLE_1'],
  FAILED_2: ['IDLE_2', 'FAILED', 'IN_RETURN'],
  RETURNED_TO_PARTNER: ['CANCELLED', 'PACKAGE_RETURNED']
}

export const PAYMENT_METHODS = {
  CASH: 'CASH',
  CASH_BY_RECIPIENT: 'CASH_BY_RECIPIENT',
  BALANCE: 'BALANCE',
  MOMO: 'MOMO',
  ZALOPAY: 'ZALOPAY',
  // SMARTPAY: 'SMARTPAY',
  VNPAY: 'VNPAY',
  VIETTELPAY: 'VIETTELPAY',
  SHOPEEPAY: 'SHOPEEPAY',
  BANKTRANSFER: 'BANKTRANSFER',
  VPBANK_PREPAID: 'VPBANK_PREPAID',
  VPBANK: 'VPBANK',
  CARD: 'CARD',
  MBBANK: 'MBBANK',
  BUSINESS_ACCOUNT: 'BUSINESS_ACCOUNT'
}

export const AHAMOVE_PAYMENT_METHODS = [
  PAYMENT_METHODS.CASH,
  PAYMENT_METHODS.CASH_BY_RECIPIENT,
  PAYMENT_METHODS.BALANCE
]

export const PAYMENT_EXPIRED_IN_MINUS = {
  MOMO: 15,
  ZALOPAY: 15,
  // SMARTPAY: 15,
  SHOPEEPAY: 15,
  VPBANK: 15
}

export const MIN_IDLE_UNTIL = 15
export const MIN_IDLE_UNTIL_MILLISECONDS = MIN_IDLE_UNTIL * 60 * 1000

export const ADVANCE_SETTING_SERVICES = [
  'SGN-TRICYCLE',
  'SGN-TRUCK-500',
  'SGN-TRUCK-1000',
  'SGN-TRUCK-2000'
]

export const DELIVERY_TYPE = {
  SAMEDAY: 'SAMEDAY',
  NATIONWIDE: 'NATIONWIDE',
  INSTANT: 'INSTANT',
  TRUCK: 'TRUCK',
  RENTAL: 'RENTAL',
  RIDE: 'RIDE',
  SAMEPRICE: 'SAMEPRICE'
}

export const WARNING_SERVICE_TYPES = {
  TWO_HOUR: '2H',
  FOUR_HOUR: '4H',
  SAME_PRICE: 'SAMEPRICE'
}

export const COD_INSURANCE = 'COD_INSURANCE'

export const DELIVERY_SERVICES_NEED_ICON = [
  DELIVERY_TYPE.INSTANT,
  DELIVERY_TYPE.TRUCK,
  DELIVERY_TYPE.RENTAL
]

export const PAGE = {
  TRUCK: 'TRUCK',
  BIKE: 'BIKE',
  PARTNER: 'PARTNER',
  DRIVER: 'DRIVER'
}

export const DISABLED_EXPORT_DATA_ORDERS = ['lazada']

export const CITY_LOCATION = {
  SGN: {
    lat: 10.768451,
    lng: 106.6943626,
    name: 'Ho Chi Minh City'
  },
  HAN: {
    lat: 21.029667,
    lng: 105.854591,
    name: 'Ha Noi City'
  }
}

export const CARRIER_TAG = 'CARRIER'
export const PARTNER_TAG = 'PARTNER'
export const SAAS_TAG = 'SAAS'

export const ETA_API = 'https://route.ahamove.com/osrm/route/v1/driving/'

export const DATA_VISUALIZATION_EXPERT = 'VIS_EXPERT'
export const URL_VISUALIZATION_PARTNER = '/live'

export const WAREHOUSE_PARTNERS = ['lazada']
export const NEED_CONFIRM_PICKUP_PARTNERS = [
  'kerryexpress',
  'fahasa',
  'greenfeed',
  'sociolla',
  'fvc',
  'ka_warehouse'
]

export const PARTNER = {
  WAREHOUSE: 'warehouse'
}

export const BOOKING_LIST_STATUS = [
  { text: 'ALL', value: '' },
  { text: 'ASSIGNING', value: 'ASSIGNING' },
  { text: 'ACCEPTED', value: 'ACCEPTED' },
  { text: 'IN PROCESS', value: 'IN PROCESS' },
  { text: 'COMPLETED', value: 'COMPLETED' },
  { text: 'CANCELLED', value: 'CANCELLED' },
  { text: 'PAYING', value: 'PAYING' },
  { text: 'IDLE', value: 'IDLE' }
]

export const BOOKING_LIST_CITY = [
  { text: 'ALL', value: '' },
  { text: 'HO CHI MINH', value: 'SGN' },
  { text: 'HA NOI', value: 'HAN' }
]

export const DEFAULT_ORDER_TAGS = ['Khách hàng tiềm năng', 'Hàng cồng kềnh', 'Trả hàng']

export const FRESH_CHAT_TAG = 'FRESHCHAT_TEST'

export const ADDRESS_TYPE = {
  HOME: 'home',
  WORK: 'work',
  SAVED_PLACE: 'saved_place',
  HISTORY: 'history',
  PREDICT_KONTAKTE: 'predict_kontakte',
  PREDICT_DEFAULT: 'predict_default' // address/ extra address or address from google
}

export const MAX_ORDER_IMAGES = 3

export const NOTIFICATION_INFO = {
  NOT_SUPPORT: 'NOT_SUPPORT',
  GRANTED: 'GRANTED',
  BLOCKED: 'BLOCKED' // denied, default
}

export const SERVICES_ALLOW_ETA = ['BIKE']

export const SIGNIN_METHODS_CONFIG = {
  firebase: 'firebase_sms_auth',
  ahamove: 'ahamove_sms_auth'
}

export const LENGTH_OF_SIGNIN_ACTIVATE_CODE = {
  firebase: 6,
  ahamove: 4
}

export const SUPPORTED_SIGIN_METHODS = {
  FIREBASE: 'firebase',
  AHAMOVE: 'ahamove'
}

export const DEFAULT_SUPPORTED_SIGIN_METHOD = SUPPORTED_SIGIN_METHODS.FIREBASE

export const COUNT_DOWN_TIME_REQUEST_SIGNIN = 59
export const COUNT_DOWN_TIME_REQUEST_EDIT_BANK = 89
export const COUNT_DOWN_TIME_REQUEST_RESET_PASSCODE = 179

export const ENVIRONMENT = ['production', 'staging']
export const BANKS_HAS_BRANCH = ['NNO\\u0026PT NONG THON VN (AGRIBANK)']

export const TRANSACTION_TYPES = {
  ALL: 'ALL',
  COD: 'COD'
}

export const TRANSACTION_WITHDRAW_COD = 'WITHDRAWAL_COD'
export const TRANSACTION_STATUS_CANCELLED = 'CANCELLED'
export const TRANSACTION_STATUS = ['TRANSFERRED', TRANSACTION_STATUS_CANCELLED, 'PENDING']

export const INPUT_MANUALLY_CATEGORY_CODE = 'OTHER'

export const LIMITED_SAVED_PLACES = 50

export const DISABLE_NEARBY_SUPPLIER_DELIVERY_TYPES = [
  DELIVERY_TYPE.SAMEDAY,
  DELIVERY_TYPE.NATIONWIDE
]
export const SUBSCRIPTION_STATUS = {
  INPROCESS: 'INPROCESS',
  COMPLETED: 'COMPLETED'
}

export const WEB_IN_APP_AHAMOVE_ID = 'ahamove'
export const WEB_IN_APP_MOMO_ID = 'momo_deeplink'
export const WEB_IN_APP_MOMO_MINIAPP = 'momo_permission'
export const WEB_IN_APP_ZALO_ID = 'zalo'
export const WEB_IN_APP_ZALOPAY_ID = 'zalopay'
// export const WEB_IN_APP_SMARTPAY_ID = 'smartpay_deeplink'
export const WEB_IN_APP_VIETTELPAY_ID = 'viettel-pay_deeplink'
export const WEB_IN_APP_VIETTEL_APP_ID = 'VIETTEL'
export const WEB_IN_APP_SHOPEEPAY_ID = 'shopee-pay_deeplink'
export const WEB_IN_APP_ONWHEEL_ID = 'onwheel'
// export const WEB_IN_APP_VPBANK_ID = 'vpbank_deeplink'
export const WEB_IN_APP_AHAUSER_ID = 'ahauser'
export const WEB_IN_APP_AHADRIVER_ID = 'ahadriver'
export const WEB_IN_APP_CONFIG = [
  {
    id: WEB_IN_APP_MOMO_ID,
    paymentMethods: [PAYMENT_METHODS.MOMO], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000 // getOrderDetailDuration === null: use default config
  },
  {
    id: WEB_IN_APP_MOMO_MINIAPP,
    paymentMethods: [PAYMENT_METHODS.MOMO], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 300000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000 // getOrderDetailDuration === null: use default config
  },
  {
    id: WEB_IN_APP_ZALO_ID,
    paymentMethods: [PAYMENT_METHODS.ZALOPAY], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 200000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
    appId: process.env.VUE_APP_WEB_IN_APP_ZALOPAY_APP_ID
  },
  {
    id: WEB_IN_APP_ZALOPAY_ID,
    paymentMethods: [PAYMENT_METHODS.ZALOPAY], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 200000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
    appId: process.env.VUE_APP_WEB_IN_APP_ZALOPAY_APP_ID
  },
  // {
  //   id: WEB_IN_APP_SMARTPAY_ID,
  //   paymentMethods: [PAYMENT_METHODS.SMARTPAY], // paymentMethods === null: allow all methods
  //   deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
  //   maxCod: 500000, // maxCod === null: use default config of service
  //   getOrderDetailDuration: 5000 // getOrderDetailDuration === null: use default config
  // },
  {
    id: WEB_IN_APP_VIETTELPAY_ID,
    paymentMethods: [PAYMENT_METHODS.VIETTELPAY], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
    appId: WEB_IN_APP_VIETTEL_APP_ID
  },
  {
    id: WEB_IN_APP_SHOPEEPAY_ID,
    paymentMethods: [PAYMENT_METHODS.SHOPEEPAY], // paymentMethods === null: allow all methods
    deliveryTypes: [DELIVERY_TYPE.INSTANT, DELIVERY_TYPE.SAMEDAY], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
    appId: WEB_IN_APP_SHOPEEPAY_ID
  },
  {
    id: WEB_IN_APP_ONWHEEL_ID,
    paymentMethods: [PAYMENT_METHODS.BALANCE], // paymentMethods === null: allow all methods
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
    appId: WEB_IN_APP_ONWHEEL_ID
  },
  // {
  //   id: WEB_IN_APP_VPBANK_ID,
  //   paymentMethods: [PAYMENT_METHODS.VPBANK], // paymentMethods === null: allow all methods
  //   maxCod: 500000, // maxCod === null: use default config of service
  //   getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  //   appId: WEB_IN_APP_VPBANK_ID
  // },
  {
    id: WEB_IN_APP_AHAUSER_ID,
    appId: WEB_IN_APP_AHAUSER_ID
  },
  {
    id: WEB_IN_APP_AHAMOVE_ID,
    appId: WEB_IN_APP_AHAMOVE_ID
  },
  {
    id: WEB_IN_APP_AHADRIVER_ID,
    appId: WEB_IN_APP_AHADRIVER_ID
  }
]

export const WEB_IN_APP_INTRO_CONFIG = [WEB_IN_APP_VIETTELPAY_ID, WEB_IN_APP_VIETTEL_APP_ID]

export const PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  TOPUP: 'top-up',
  ORDER: 'order',
  REIMBURSEMENT: 'reimbursement',
  POD: 'pod',
  TIP: 'tip',
  AHARENT: 'aharent'
}

export const PAYMENT_TYPE_WITH_BALANCE = [
  PAYMENT_TYPE.SUBSCRIPTION,
  PAYMENT_TYPE.REIMBURSEMENT,
  PAYMENT_TYPE.TIP
]

export const REQUEST_SUBTYPE = {
  POD: 'POD',
  EPAYMENT_ON_DELIVERY: 'epayment_on_delivery'
}

export const PAYMENT_METHODS_AHAMOVE = {
  CASH: 'cash',
  BALANCE: 'balance',
  VNPAY: 'vnpay',
  MOMO: 'momo',
  ZALOPAY: 'zalopay',
  ZALO: 'zalo',
  // SMARTPAY: 'smartpay',
  VIETTELPAY: 'viettelpay',
  SHOPEEPAY: 'shopeepay',
  BANKTRANSFER: 'banktransfer',
  VPBANK_PREPAID: 'vpbank_prepaid',
  CARD: 'card',
  BUSINESS_ACCOUNT: 'business_account'
}

export const SSO = {
  VNPAY: 'vnpay',
  MOMO: 'momo',
  ZALOPAY: 'zalopay',
  ZALO: 'zalo',
  SMARTPAY: 'smartpay',
  VIETTELPAY: 'viettelpay',
  SHOPEEPAY: 'shopeepay'
}

export const SSO_CONFIG = [
  {
    id: WEB_IN_APP_ZALOPAY_ID,
    op_server: process.env.VUE_APP_WEB_IN_APP_ZALOPAY_OP_SERVER,
    client_id: process.env.VUE_APP_WEB_IN_APP_ZALOPAY_APP_ID, // appID of merchant
    redirect_uri: `${process.env.VUE_APP_BASE_URL}/sso/${SSO.ZALOPAY}`,
    response_type: '',
    scope: 'openid phone', // get both: displayName and phone
    state: '',
    api_server: process.env.VUE_APP_WEB_IN_APP_ZALOPAY_API_SERVER // sandbox
  }
]

export const USER_TYPE = {
  INDIVIDUAL: 'Individual',
  SME: 'SMEs',
  CORPORATION: 'Corporation'
}

export const STATUS_VERIFY_EKYC = {
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  IN_REVIEW: 'IN_REVIEW'
}

export const IMAGE_TYPE = {
  BIZ_LICENSE_FRONT_IMG: 'business_license_front_image_url',
  BIZ_LICENSE_BACK_IMG: 'business_license_back_image_url',
  STORE_IMG_URL: 'store_image_url'
}

export const VERIFY_ACCOUNT_STATUS = {
  APPROVED_ID: 'APPROVED_ID',
  SUBMITTED: 'SUBMITTED',
  COMPLETED: 'COMPLETED',
  REJECT: 'REJECT'
}

export const KA_RO_ADDITIONAL_FIELDS = {
  ADDRESS_DETAIL: 'address_detail',
  BULKY_PACKAGE: 'bulky_package',
  ORDER_VALUE: 'order_value',
  ORDER_CHANNEL: 'order_channel',
  ORDER_PRIORITY: 'order_priority',
  BILL_VALUE: 'bill_value',
  USER_RANK: 'user_rank',
  USER_SPECIAL_REQUESTS: 'user_special_requests',
  SUPPLIER_SPECIAL_REQUEST: 'supplier_special_requests'
}

export const EKYC_KEY = {
  FRONTSIDE: 'id_card_front',
  BACKSIDE: 'id_card_back',
  AVATAR: 'avatar',
  VIDEO: 'vid_liveness'
}

export const HOMEPAGE_PLATFORM = {
  WAP: 'WAP',
  WEB: 'WEB',
  EMBED: 'EMBED'
}
export const EKYC_PROVIDER = {
  HV: 'HV',
  FPT: 'FPT',
  CREDIT_SCORE_VALUE: 80
}

export const STATUS_DRAFT = {
  SAVED_DRAFT: 'SAVED_DRAFT',
  COMPLETED_CHECKING_DRAFT: 'COMPLETED_CHECKING_DRAFT'
}

export const CREATE_VIRTUAL_ACCOUNT = {
  SUCCESS: 'success'
}

export const VACCINATED_STATUS = ['1st_dose', '2nd_dose', 'recovery']

export const REIMBURSEMENT_ORDER_STATUS = {
  CONFIRM: 1,
  PAID: 2
}

export const PAYMENT_METHODS_WITH_PROOF = [
  PAYMENT_METHODS_AHAMOVE.BANKTRANSFER,
  PAYMENT_METHODS_AHAMOVE.CASH
]

export const API_PLACE_SOURCE = {
  PELIAS: 'pelias',
  GOOGLE: 'google',
  GOONG: 'goong',
  VIETBANDO: 'vietbando',
  IOT: 'iot'
}

export const SERVICE_HAVE_HUB_SP_TRANSFER_COD_REQUEST = [
  'SGN-HUB-SP',
  'SGN-TMDT',
  'SGN-HUB-SP-14H',
  'HAN-HUB',
  'HAN-HUB-13',
  'HAN-TMDT',
  'SGN-HUB-SE'
]

export const HARDCODED_PARTNER = {
  BIGC: 'bigc',
  HOMEFARM: 'homefarm',
  COOP_MART: 'coopmart',
  KA_WAREHOUSE: 'ka_warehouse',
  ANCUONG: 'ancuong',
  B2B_TRUCK: 'internaltruck'
}

export const METABASE_PARAMS = {
  COOP_MART_STORE_NUMBER: 'mã_điểm_giao',
  COOP_MART_ZONE_NAME: 'mã_khu_vực'
}

export const bigCChannels = [
  { key: 'route_optimization.bigc.channel.online', value: 'online' }
  // { key: 'route_optimization.bigc.channel.offline', value: 'offline' }
]

export const ONWHEEL_RO_IMPORT_TEMPLATE = {
  COOP_MART:
    'https://cdn.ahamove.com/app/others/onwheel_sgc_route_optimization_import_template.xlsx'
}

export const bigCChannelGrid = ['OFFLINE', 'TEL', 'MOB', 'ZLC', 'ZLS', 'Omni-B2B', 'B2B ONLINE']

export const bigCChannelMapping = {
  OFFLINE: 'OFFLINE',
  TEL: 'TELESALES',
  BIC_APP: 'GO! BIGC APP',
  BIC_WEB: 'GO! BIGC WEB',
  ZLC: 'ZALO CHAT',
  ZLOA: 'ZALO OA',
  FBC: 'FACEBOOK CHAT',
  FBS: 'FACEBOOK SHOP',
  LIV: 'Live stream',
  OMNI_B2B: 'Omni-B2B'
}

export const coopMartOrderPriorityMapping = {
  FRESH_FROZEN_FOOD: 'Thực phẩm tươi sống, đông lạnh',
  PLATINUM_MEMBER: 'Khách hàng Bạch Kim',
  CUSTOMER_PAYS_FEE: 'Khách hàng trả phí giao hàng'
}

export const TIP_TYPE = {
  FLAT: 'FLAT',
  PERCENTAGE: 'PERCENTAGE'
}

export const SUPPLIER_SUB_STATUS = {
  COMPLETING: 'COMPLETING'
}

export const HARDCODED_PARTNER_CONFIG = {
  ANCUONG: {
    DEFAULT_SERVICE_ID: 'VNM-PARTNER-ANCUONG',
    DEFAULT_SOURCE_WAREHOUSE: 'THÁI HÒA',
    BANNER_URL: 'https://vncdn.ahamove.com/banner/fd931b99815ea293f249374937beaa225441f288.png',
    REPORT_VEHICLE_URL:
      'https://bi.ahamove.com/public/question/33d917b0-cabb-4db5-bff8-03db20d3b312'
  },
  COOP_MART: {
    SERVICES: {
      INHOUSE: 'inhouse',
      PUBLIC: 'public'
    }
  },
  BIGC: {
    // TIME_WINDOWS: {
    //   6: [600, 720], // 10:00 - 12:00
    //   7: [600, 720], // 10:00 - 12:00
    //   8: [600, 720], // 10:00 - 12:00
    //   9: [720, 840], // 12:00 - 14:00
    //   10: [720, 840], // 12:00 - 14:00
    //   11: [840, 960], // 14:00 - 16:00
    //   12: [840, 960], // 14:00 - 16:00
    //   13: [960, 1080], // 16:00 - 18:00
    //   14: [960, 1080], // 16:00 - 18:00
    //   15: [1080, 1200], // 18:00 - 20:00
    //   16: [1080, 1200], // 18:00 - 20:00
    //   // 17: [480, 600], // 08:00 - 10:00
    //   // 18: [480, 600], // 08:00 - 10:00
    //   // 19: [480, 600], // 08:00 - 10:00
    //   // 20: [600, 720], // 10:00 - 12:00
    //   // 21: [600, 720], // 10:00 - 12:00
    //   // 22: [720, 840], // 12:00 - 14:00
    //   // 23: [720, 840] // 12:00 - 14:00
    //   17: [600, 720], // 10:00 - 12:00
    //   18: [600, 720], // 10:00 - 12:00
    //   19: [600, 720], // 10:00 - 12:00
    //   20: [600, 720], // 10:00 - 12:00
    //   21: [600, 720], // 10:00 - 12:00
    //   22: [600, 720], // 10:00 - 12:00
    //   23: [600, 720] // 10:00 - 12:00
    // },
    TIME_WINDOWS: {
      // 12:00 - 14:00
      6: [720, 840],
      7: [720, 840],
      8: [720, 840],
      9: [720, 840],

      // 14:00 - 16:00
      10: [840, 960],
      11: [840, 960],

      // 16:00 - 18:00
      12: [960, 1080],
      13: [960, 1080],

      // 18:00 - 20:00
      14: [1080, 1200],
      15: [1080, 1200],
      16: [1080, 1200],

      // 08:00 - 10:00
      17: [480, 600],
      18: [480, 600],
      19: [480, 600],
      20: [480, 600],
      21: [480, 600],
      22: [480, 600],
      23: [480, 600]
    },
    AHAMOVE_CARRIER: 'ahamove',
    CARRIERS: [
      { name: 'Inhouse', _id: 'inhouse' },
      { name: 'Ahamove', _id: 'ahamove' },
      { name: 'GO 3PLs', _id: 'threepl' },
      { name: 'Giao tại sảnh', _id: 'GHST' },
      { name: 'Khách đến lấy', _id: 'KĐL' },
      { name: 'Giao tại sảnh', _id: 'gts' }
    ],
    BACKLOG_REPORT_URL:
      'https://bi.ahamove.com/public/question/ad8f69b3-820f-4869-bc87-d5613dedad7c?summary=true',
    INBOUND_REPORT_URL: {
      STAG: 'https://bi.ahamove.com/public/dashboard/eed9dd19-d868-41ff-a2a0-505b60804cd0?summary=true',
      PROD: 'https://bi.ahamove.com/public/dashboard/9d679b9a-6ab0-43b0-8d95-4b7e26b4a030?summary=true'
    },
    OUTBOUND_REPORT_URL: {
      STAG: 'https://bi.ahamove.com/public/dashboard/3d7ce4b6-e9b0-4cc6-a861-ec44aa9c1637',
      PROD: 'https://bi.ahamove.com/public/dashboard/d2cc8901-41ce-4159-99b5-00b50bab91ac'
    },
    SHIPPING_TYPE: {
      1: {
        text: 'Hỏa tốc',
        value: '1H'
      },
      2: {
        text: 'Tiêu chuẩn',
        value: 'GHTN'
      },
      3: {
        text: 'Nhận hàng tại siêu thị',
        value: 'GHST'
      }
    },
    INHOUSE_SERVICE_ID: 'VNM-PARTNER-BIGC'
  }
}

export const WITHDRAW_PAYMENT_METHODS = {
  PAYME: 'payme',
  BANK: 'bank'
}

export const PAYME_STATUS = {
  NOT_ACTIVATED: 'NOT_ACTIVATED',
  NOT_KYC: 'NOT_KYC',
  KYC_APPROVED: 'KYC_APPROVED',
  KYC_REVIEW: 'KYC_REVIEW',
  KYC_REJECTED: 'KYC_REJECTED'
}

export const COD_WITHDRAW = {
  MIN_AMOUNT: 20000
}

export const UPLOAD_FILE_TYPE = {
  ORDER_PROOF: 'order_proof',
  AVATAR: 'avatar',
  ID_CARD_FRONT: 'id_card_front',
  ID_CARD_BACK: 'id_card_back',
  FAMILY_REGISTER_FRONT: 'family_register_front',
  FAMILY_REGISTER_BACK: 'family_register_back',
  CRIMINAL_RECORD: 'criminal_record',
  VEHICLE_DECALS_1: 'vehicle_decals_1',
  VEHICLE_DECALS_2: 'vehicle_decals_2',
  VEHICLE_DECALS_3: 'vehicle_decals_3',
  VEHICLE_REGISTRATION: 'vehicle_registration',
  REGISTRATION_CERTIFICATE_FRONT: 'registration_certificate_front',
  REGISTRATION_CERTIFICATE_BACK: 'registration_certificate_back',
  DRIVER_LICENSE: 'driver_license',
  DRIVER_LICENSE_FRONT: 'driver_license_front',
  DRIVER_LICENSE_BACK: 'driver_license_back',
  LICENSE_PLATES: 'license_plates',
  '1ST_DOSE': '1st_dose',
  '2ND_DOSE': '2nd_dose',
  RECOVERY: 'recovery',
  VEHICLE_PHOTO: 'vehicle_photo',
  ADDRESS: 'address',
  PERSONAL_TAX: 'personal_tax',
  PLATE_NUMBER: 'plate_number'
}

export const WEB_IN_APP_EVENT = {
  CLOSE: 'close',
  BACK: 'back',
  HIDE_TOOLBAR: 'hide_toolbar',
  GET_TOKEN: 'getToken',
  OPEN_PAGE: 'openPage',
  PAYMENT: 'payment',
  REFRESH_TOKEN: 'refreshToken'
}

export const IN_APP_SCREEN = {
  BALANCE: `ahamove://balance?open_topup=true`,
  RECORDS: `ahamove://records`,
  ORDER_DETAIL: (orderId) => `ahamove://order_detail?pay_now=true&order_id=${orderId}`,
  NEW_ORDER: `ahamove://new_order`,
  EV: `ahamove://aharide`
}

export const RENTAL_DEFAULT_NUMBER_OF_DRIVER = 1

export const ORDER_TYPE = {
  RENT: 'rent',
  TRUCK: 'truck',
  EV: 'ev'
}
export const DELETE_ACCOUNT_STATUS = {
  ORDER_STILL_EXISTED: 'ORDER_STILL_EXISTED',
  ORDER_STORE_STILL_EXISTED: 'ORDER_STORE_STILL_EXISTED',
  COD_NOT_EMPTY: 'COD_NOT_EMPTY',
  USER_DEACTIVATED_FROM_APP: 'USER_DEACTIVATED_FROM_APP'
}
export const SURGE_PRICE_DISPLAY_CONFIG = 'surge_price_display_config'
export const REMOTE_CONFIG_KEY = {
  SURGE_PRICE_DISPLAY_CONFIG: 'surge_price_display_config',
  USER_ENABLE_PASSCODE: 'user_enable_passcode',
  ENABLE_HOME_PAGE: 'enable_homepage_web',
  USER_UPDATE_CATEGORY_REWARD_POINT: 'user_update_category_reward_point',
  USER_USE_EKYC: 'user_use_ekyc',
  EKYC_PROVIDER: 'ekyc_provider',
  USER_TIPS_DEADLINE_SEC: 'user_tips_deadline_sec',
  USER_REIMBURSEMENT_DEADLINE_SEC: 'user_reimbursement_deadline_sec'
}
export const USER_ENABLE_PAYME_V2 = 'user_enable_payme_v2'

export const SURGE_RATE = 1

export const REPORT_DRIVER_PERFORMANCE = 'report_driver_performance'

export const REPORT_PRICE_REVIEW = 'price_review'
export const MAX_FAVORITED_DRIVER = 200

export const ORDER_CANCEL_ACTION_TYPE = {
  REBROADCAST: 'rebroadcast',
  REORDER: 'reorder',
  CANCEL: 'cancel',
  CHANGE_INFO: 'change_info'
}

export const ORDER_ENTRY_POINT = {
  SELECT_VEHICLE: 'select_vehicle',
  PLACE_ORDER: 'place_order',
  CONFIRM_ORDER: 'confirm_order',
  ORDER_DETAIL_ASSIGNING: 'order_detail_assigning'
}

export const ACCEPTS_VERSION = 3
export const NEW_UI_TRUCK = 'NEWUI_TRUCK'

export const ADR_SOURCE_PREFIX = {
  SAVED_PLACE: 'fav'
}

export const URL_DOWNLOAD_AHA_APP = 'https://ahamove.onelink.me/fmLb/a2hzkkun'

export const MAX_ITEM_VALUE_DEFAULT = {
  TRUCK: 100000000,
  BIKE: 30000000
}

export const INSURANCE_PACKAGE_TYPE = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
  VIP: 'vip',
  NONE: 'none'
}

export const INSURANCE_PACKAGE_OPTIONS = [
  {
    id: INSURANCE_PACKAGE_TYPE.BASIC,
    name: 'Gói tiêu chuẩn',
    description: 'Mức bồi thường tối đa lên đến 5.000.000đ',
    from: 0,
    to: 5000001,
    price: 1000,
    compensation: 5000000
  },
  {
    id: INSURANCE_PACKAGE_TYPE.ADVANCED,
    name: 'Gói Nâng cao',
    description: 'Mức bồi thường tối đa lên đến 10.000.000đ',
    from: 5000001,
    to: 10000001,
    price: 2000,
    compensation: 10000000
  },
  {
    id: INSURANCE_PACKAGE_TYPE.VIP,
    name: 'Gói Cao cấp',
    description: 'Mức bồi thường tối đa lên đến 30.000.000đ',
    from: 10000001,
    to: 30000001,
    price: 10000,
    compensation: 30000000
  },
  {
    id: INSURANCE_PACKAGE_TYPE.NONE,
    name: 'Không khai giá hàng hóa',
    description: 'Không được đền bù khi hàng hóa bị mất mát, hư hại'
  }
]

export const NAVBAR_GROUP_ID = {
  SERVICE: 'service',
  ORDER: 'order',
  ACCOUNT: 'account',
  REWARD: 'reward',
  SUPPORT: 'support',
  OTHER: 'other'
}
